import Vue from 'vue'
import Vuex from 'vuex'

import userInfo from './modules/userInfo.js'
import VueXAlong from 'vuex-along'
Vue.use(Vuex)


export default new Vuex.Store({
  modules: {
	userInfo
  },
  // plugins: [createVuexAlong()]
  plugins: [VueXAlong({
		name: 'integral',     //存放在localStroage或者sessionStroage 中的名字
		local: false, 
		session: { list: [], isFilter: true },
		})
	]
})

